// @flow

import React from 'react';

type Props = {
  phone: string,
};

const PhoneLink = (props: Props) => {
  const { phone } = props;
  if (!phone) {
    return (
      <span>N/A</span>
    );
  }

  return (
    <a href={`tel:${phone.replace(/\s+/g, '')}`}>{phone}</a>
  );
};

export default PhoneLink;



// WEBPACK FOOTER //
// ./src/js/Components/PhoneLink.js